import slugify from "slugify";
import Link from "../../components/link";

const SlugLink = ({ baseLink = null, text = null, children }) => {
  const slug = slugify(text ? text : children, {
    lower: true,
  });
  return (
    <Link href={baseLink != null ? `${baseLink}#${slug}` : `#${slug}`}>
      {children}
    </Link>
  );
};

export default SlugLink;
